import { ActionIcon, ConditionalWrapper, Tooltip } from 'ui';
import { IconMap } from 'ui/Icons';

type UserLocationButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
};

const UserLocationButton = ({ onClick, disabled = true }: UserLocationButtonProps) => {
  return (
    <ConditionalWrapper
      condition={disabled}
      wrapper={(children) => <Tooltip label="Please enable location access">{children}</Tooltip>}
    >
      <ActionIcon variant="white" color="gray" onClick={onClick} disabled={disabled}>
        <IconMap />
      </ActionIcon>
    </ConditionalWrapper>
  );
};

export { UserLocationButton };
